import React, { useState, useEffect } from 'react'
import { useRolePermissions } from 'api/hooks/use-role-permissions'
import Select, { components } from 'react-select'

function PermissionDropdown({ roleId, params, setParams }) {
  const [selected, setSelected] = useState('')
  const defaultParams = {
    role_id: roleId,
    is_expansive: true,
    category: '',
    page: 1,
    perPage: 1000
  }

  const { Option } = components
  const { data: permissions, isSuccess } = useRolePermissions({
    params: defaultParams
  })

  const CustomOption = (props) => (
    <Option {...props}>
      <span className="me-1">{props.data.label}</span>
    </Option>
  )
  const SingleValue = ({ children, ...props }) => (
    <React.Fragment>
      <components.SingleValue {...props}>{children}</components.SingleValue>
    </React.Fragment>
  )

  const options = isSuccess
    ? permissions.data.map((obj) => ({
        label:
          obj.permission['category_caption'] +
          ': ' +
          obj.permission['description'],
        value: obj.permission['id'],
        permissionId: obj['permission_id']
      }))
    : []

  useEffect(() => {
    if (params.permission_id && isSuccess) {
      const selectedOption = options.find(
        (option) => option.permissionId === params.permission_id
      )
      setSelected(selectedOption)
    } else {
      setSelected('')
    }
  }, [params.permission_id, isSuccess]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {isSuccess && (
        <Select
          options={options}
          styles={{ zIndex: 100 }}
          value={selected}
          isClearable={true}
          placeholder="Select Permission"
          onChange={(val) => {
            setSelected(val)
            setParams({ ...params, permission_id: val?.value })
          }}
          id="permission-selector"
          isOptionDisabled={(option) => option.disabled}
          components={{ SingleValue, Option: CustomOption }}
        />
      )}
    </>
  )
}

export default PermissionDropdown
